import {
  apiRoutes,
  getServiceDetailFn,
  type DefaultQueryError,
  type Service,
  type ServiceDetailParams,
} from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

const useGetServiceDetail = (
  params: ServiceDetailParams,
  opts?: UseQueryOptions<Service, DefaultQueryError>
) =>
  useQuery<Service, DefaultQueryError>({
    queryKey: [apiRoutes.master_data, params],
    queryFn: () => getServiceDetailFn(params),
    ...opts,
  });

export default useGetServiceDetail;
